import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {Question} from '../../models/underwriter.model';
import {newGuid} from '../question-helper';

declare var $: any;

@Component({
    selector: 'app-question-rebuild-cost',
    templateUrl: './question-rebuild-cost.component.html',
    styleUrls: ['./question-rebuild-cost.component.scss'],
    standalone: false
})
export class QuestionRebuildCostComponent implements OnInit, OnChanges {

  @Input() question: Question;
  @Input() readOnly = false;
  @Output() questionAnswer = new EventEmitter<any>();

  uniqueControlName = `textbox-${newGuid()}`;
  uniqueId = `textbox-${newGuid()}`;
  squareMeterValue: number;
  finishingValue = 1;

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.question?.currentValue) {
      this.question = changes.question.currentValue;
    }
  }

  onInputChange(): void {
    if (this.squareMeterValue < 0) {
      this.squareMeterValue = 0;
    }
    if (this.squareMeterValue && this.finishingValue && this.question) {
      let rebuild = 0;

      switch (this.finishingValue) {
        case 1:
          rebuild = this.squareMeterValue * 12000;
          break;
        case 2:
          rebuild = this.squareMeterValue * 13000;
          break;
        case 3:
          rebuild = this.squareMeterValue * 15000;
          break;
      }

      if (this.question?.max_val && rebuild > this.question?.max_val) {
        rebuild = this.question?.max_val;
      }
      if (this.question?.min_val && rebuild < this.question?.min_val) {
        rebuild = this.question?.min_val;
      }
      this.question.answer = rebuild.toString();
      this.questionAnswer.emit(this.question);
    }
  }
}
